import React from "react";
import styles from "./viewTreatment.module.scss";
import { signedLockedAccess } from "../../../utils";
import { useSelector } from "react-redux";
import { assessmentRbacChecker } from "../../../utils/rbac";
import editIcon from "../../../static/images/edit-icon-blue.png";
import { EDIT } from "../../../constants";
import { useReadOnly } from "../../../hooks/useReadOnly";

export const TreatmentEditIcon = ({ editable, handleEdit }) => {
  const assessmentDetails = useSelector((state) => state.patient.detailAssessment);
  const patientData = useSelector((state) => state.patient.detailViewData);
  const userDetails = useSelector((state) => state.user);
  const hideButtons = assessmentRbacChecker(userDetails?.role, patientData?.isOwnCustomer);
  const isReadOnly = useReadOnly();

  return (
    !editable &&
    signedLockedAccess(assessmentDetails?.assessmentStage) &&
    hideButtons && (
      <div className={`${styles.edit_icon}`}>
        <button className={`float-sm-right ${styles.tab_edit} handleEdit`} onClick={handleEdit} disabled={isReadOnly}>
          <img src={editIcon} alt="edit" />
          {EDIT}
        </button>
      </div>
    )
  );
};
